module.exports = __webpack_public_path__ + "static/media/img_background_jjk.303fc4b2.jpeg";